/* eslint-disable */
import { FormikTouched } from 'formik';
import * as Yup from 'yup';

export const getTouchedConfigForValidatingFields = (
  objectScheme: Yup.AnyObjectSchema
): FormikTouched<any> => {
  const validationSchemaFields = Object.keys(objectScheme.fields);
  const touchedConfig = validationSchemaFields.reduce((acc, key) => {
    acc[key] = true;
    return acc;
  }, {} as FormikTouched<any>);
  return touchedConfig;
};
